export const LOCAL_STORAGE_ACCESS_TOKEN = 'lspAccessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'lspRefreshToken'
export const LOCAL_STORAGE_AUTHENTICATED_USER = 'lspAuthenticatedUser'
export const LOCAL_STORAGE_IS_AUTHENTICATED = 'lspIsAuthenticated'
